import ProjectsWithSamples from "@/components/dashlets/ProjectsWithSamples.vue";
import StackedBarChart from "@/components/dashlets/StackedBarChart.vue";
import SamplesOrdered from "@/components/dashlets/ColorVersionOrdered.vue";
import ColorVersionConfirmed from "@/components/dashlets/ColorVersionConfirmed.vue";
import UnreadMessagesDashletForOffers from "@/components/dashlets/UnreadMessagesDashletForOffers.vue";
import UnreadMessagesDashletForInquiry from "@/components/dashlets/UnreadMessagesDashletForInquiry.vue";
import UnreadMessagesDashletForPPSample from "@/components/dashlets/UnreadMessagesDashletForPPSample.vue";
import UnreadMessagesDashletForSample from "@/components/dashlets/UnreadMessagesDashletForSample.vue";


const Dashlets = [
    ProjectsWithSamples,
    SamplesOrdered,
    ColorVersionConfirmed,
    StackedBarChart,
    UnreadMessagesDashletForOffers,
    UnreadMessagesDashletForInquiry,
    UnreadMessagesDashletForPPSample,
    UnreadMessagesDashletForSample,
]

export default Dashlets;